
<template>
  <button @click="clickBtn" class="icon-btn play" :class="props.btnClass">
    <IconDef name="play"/>
  </button>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue"
const props = defineProps({
  btnClass: {
    type: String,
    default: ''
  },
})
</script>
